<section class="l-common">
  <div class="p-auth">
    <div class="p-auth-login">
      <div class="p-auth-login__wrapper">
        <div class="text-center u-mg30t u-mg30b">
          <img src="./assets/images/logo_BLc.png" width="100%" alt="Maintenancs.C">
        </div>
        <form [formGroup]="form?.formGroup" novalidate>
          <div class="p-auth-login__panel">
            <div class="p-auth-login__panel--name">ログインID</div>
            <bl-text-input [option]="{ allows: ['number', 'alphabet', 'symbol'], convertHalf: true, denySpace: true }"
              [value]="userId" (changeEvent)="onChangeUserId($event)" [placeholder]="'ログインIDを入力して下さい'" [addClass]="'form-control p-auth-login__panel--input'"
              [validator]="form?.validatorGroup['UserLoginInfo#accountID']"
              [autocomplete]="'username'"
            ></bl-text-input>
            <div class="p-auth-login__panel--name p-auth-login__panel--input-margin">パスワード</div>
            <bl-text-input blCustomFocus [option]="{ allows: ['number', 'alphabet', 'symbol'], convertHalf: true, denySpace: true }"
              [enter]="onPasswordInputEnter" [value]="password" (changeEvent)="onChangePassword($event)" [password]="true" [placeholder]="'パスワードを入力して下さい'"
              [addClass]="'form-control p-auth-login__panel--input password-input'"
              [validator]="form?.validatorGroup['UserLoginInfo#password']"
              [autocomplete]="'current-password'"
            ></bl-text-input>
            <div *ngIf="logout != null" class="p-auth-login__panel--red p-auth-login__panel--input-margin">{{logout}}</div>
            <div *ngIf="message != null" class="p-auth-login__panel--red p-auth-login__panel--input-margin">{{message}}</div>
            <div class="p-auth-login__btn-group">
              <button id="submit" type="button" (click)="onLogin()" class="btn btn-success p-auth-login__panel--btn">
                <span>ログイン</span>
              </button>
            </div>
            <a href="/contract/password/mail-address-input-page">ログインID/パスワードをお忘れですか？</a>
          </div>
        </form>
        <div class="line-height">
          <p class="color-green">動作確認ブラウザ</p>
          <p>本サービスを安全にご利用いただくためには、Google Chromeを推奨いたします。Chromeは<a href="javascript:void(0)" (click)="onOpenChrome($event)" class="text-link">こちら</a>より簡単にインストールできます。</p>
        </div>
        <div class="privacy">
          <a href="./privacy.html" target="_blank" class="text-link">情報の外部送信について</a>
        </div>
      </div>
    </div>
  </div>
</section>



// WEBPACK FOOTER //
// ./src/app/page/login-page/login-page.component.html